/**
 * Where each passage's questions sit on a paper: { passageId -> { first, last, count } }
 * (0-based indexes). The server keeps a set together, so first..last is the
 * set; `count` is how many of them there are, in case an old paper did not.
 *
 * @param {Array<{ passage?: string }>} questions in paper order
 */
export function passageRanges(questions) {
  const out = {};
  (questions || []).forEach((q, i) => {
    const pid = q?.passage ? String(q.passage) : null;
    if (!pid) return;
    const r = out[pid];
    if (!r) out[pid] = { first: i, last: i, count: 1 };
    else {
      r.last = i;
      r.count += 1;
    }
  });
  return out;
}

/** "Question 4" / "Questions 4–7" / "4 questions" for a set's range. */
export function rangeLabel(range) {
  if (!range) return "";
  const contiguous = range.last - range.first + 1 === range.count;
  if (range.count === 1) return `Question ${range.first + 1}`;
  if (contiguous) return `Questions ${range.first + 1}–${range.last + 1}`;
  return `${range.count} questions`;
}
